import { addReminder, deleteReminderById, getAllReminder, getReminderById, updateReminder } from "../../../helpers/backend_helper";
import { getReminderByIdError, getReminderByIdSuccess, reminderError, reminderRequest, reminderSuccess } from "./reducer";

export const fetchReminder = (page:number,count:number,keyword?:string) => async (dispatch: any) => {
    dispatch(reminderRequest());
    try {
      const response: any = await getAllReminder(page,count,keyword);
      if (response && response.isSuccess) {
        dispatch(reminderSuccess(response.data));
        return response
      } else {
        dispatch(reminderError("Failed to fetch reminder"));
        return response
      }
    } catch (error: any) {
      dispatch(reminderError(error.message));
      return null
    }
  };


  
   export const addNewReminder = (data: any) => async (dispatch: any) => {
      dispatch(reminderRequest());
      try {
        const response: any = await addReminder(data);
        if (response && response.data) {
          dispatch(reminderSuccess(response.data));
          return response 
        } else {
          dispatch(reminderError("Failed to add maintenance"));
        }
      } catch (error: any) {
        dispatch(reminderError(error.message));
      }
    };
    
    export const editReminder = (data: any) => async (dispatch: any) => {
      dispatch(reminderRequest());
      try {
        const response: any = await updateReminder(data);
        if (response.data && response.isSuccess) {
          dispatch(reminderSuccess(response));
          return response 
        } else {
          dispatch(reminderError("Failed to edit maintenance"));
          return response 
        }
      } catch (error: any) {
        dispatch(reminderError(error.message));
        return null
      }
    };
   
    export const fetchReminderById = (userId: string) => async (dispatch: any) => {
      dispatch(reminderRequest());
      try {
        const response: any = await getReminderById(userId);  
    
        if (response && response.isSuccess) {
          dispatch(getReminderByIdSuccess(response.data)); 
          return response;  
        } else {
          dispatch(getReminderByIdError("Failed to fetch Fuel by ID"));
          return null; 
        }
      } catch (error: any) {
        dispatch(getReminderByIdError(error.message));  
        return null;
      }
    };  

   export const deleteReminder = (id: string) => async (dispatch: any) => {
      dispatch(reminderRequest());
      try {
        const response: any = await deleteReminderById(id);  
    
        if (response && response.isSuccess) {
          dispatch(reminderSuccess(response.data)); 
          return response; 
        } else {
          dispatch(reminderError("Failed to fetch Part Inventory by ID"));
          return null; 
        }
      } catch (error: any) {
        dispatch(reminderError(error.message));  
        return null;
      }
    }